import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, formValueSelector} from 'redux-form';

import Label from 'components/Label';
import FormField from 'components/FormField';
import ErrorBlock from 'components/ErrorBlock';
import {TextField, AsyncSelectField} from 'components/Fields';
import {TenantInfoOption} from 'components/TenantInfo';

import {required, validEmail} from 'utils/validators';
import {clearField} from 'utils/forms';

import {addSecondaryTenant} from 'ducks/bookings';

import {searchTenants} from 'sdk/bookings';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {fullName, email} = values;
  const {bookingId} = props;

  dispatch(
    addSecondaryTenant(
      {bookingId, fullName, email: _.get(email, 'value')},
      props.getExtraActions()
    )
  );
};

const validate = values => ({email: validEmail(_.get(values, 'email.value'))});

class AddSecondaryTenantForm extends React.Component<any> {
  fetchTenants = value => searchTenants({value});

  clearTenant = () => {
    clearField(this, {field: 'email'});
    clearField(this, {field: 'fullName'});
  };

  createNewTenantPrompt = label => `Create new tenant "${label}"`;
  buildTenantOptions = data =>
    data.results.map(tenant => ({
      value: tenant.email,
      label: tenant.email,
      object: tenant
    }));

  render() {
    const {error, disableFullName, withoutFullName} = this.props;

    const fullNamePlaceholder = disableFullName
      ? withoutFullName ? '' : 'Add email first'
      : "Add tenant's full name";

    return (
      <form className="AddSecondaryTenantForm">
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <FormField>
          <Label>Email</Label>
          <Field
            name="email"
            validate={[required]}
            component={AsyncSelectField}
            creatable={true}
            placeholder="Search for an existing tenant ..."
            fetchFunction={this.fetchTenants}
            buildOptions={this.buildTenantOptions}
            promptTextCreator={this.createNewTenantPrompt}
            onClear={this.clearTenant}
            optionRenderer={TenantInfoOption}
          />
        </FormField>
        <FormField>
          <Label>Full Name</Label>
          <Field
            name="fullName"
            placeholder={fullNamePlaceholder}
            component={TextField}
            disabled={disableFullName}
          />
        </FormField>
      </form>
    );
  }
}

const formSelector = formValueSelector('addSecondaryTenantForm');

const mapStateToProps = state => {
  const email = formSelector(state, 'email');

  const initialValues = {fullName: _.get(email, 'object.fullName')};

  const disableFullName = _.isNil(email) || email.object;

  const withoutFullName = initialValues.fullName !== undefined;

  return {initialValues, disableFullName, withoutFullName};
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addSecondaryTenantForm',
    onSubmit: formSubmit,
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  })(AddSecondaryTenantForm)
);
